import { Component, inject, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalRef } from '@eg/ui';
import { setUpTOTP, updateMFAPreference, verifyTOTPSetup } from '@aws-amplify/auth';
import { UserStoreService } from '../../store/user';
import { TranslocoService } from '@jsverse/transloco';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'rmb-mfa-registration',
  templateUrl: './mfa-registration.component.html',
  styleUrls: ['./mfa-registration.component.scss'],
  standalone: false,
})
export class MfaRegistrationComponent implements OnInit {
  private modalRef = inject(ModalRef);
  private userStoreService = inject(UserStoreService);
  private translocoService = inject(TranslocoService);

  readonly TRANSLOCO_PREFIX = 'auth.mfa';

  readonly loading = signal(false);
  errorMessage: string;
  infoMsg: string;
  qrCodeString: string;

  form: FormGroup = new FormGroup({
    otpCode: new FormControl<string>(undefined, [Validators.required]),
  });

  async ngOnInit() {
    const totpSetupDetails = await setUpTOTP();
    const appName = 'railMybox';
    const userEmail = this.userStoreService.getUserQuery().getUserEmail();
    const setupUri = totpSetupDetails.getSetupUri(appName, userEmail);
    this.qrCodeString = setupUri.toString();
  }

  async onVerifyTOTP(): Promise<void> {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.errorMessage = undefined;
    this.loading.set(true);

    try {
      const { otpCode } = this.form.getRawValue();
      await verifyTOTPSetup({ code: otpCode.trim() });
      this.infoMsg = this.TRANSLOCO_PREFIX + '.verified';
      await updateMFAPreference({ totp: 'PREFERRED' });

      this.executeAfter(3000, async () => {
        this.close();
      });
    } catch (err) {
      this.errorMessage = this.translocoService.translate('auth.errors.' + err.name);
    }
    this.loading.set(false);
  }

  private executeAfter(time: number, callback: () => void | Promise<void>): void {
    interval(time).pipe(take(1)).subscribe(callback);
  }

  close() {
    this.modalRef.close();
  }
}
